import { useLocation, useNavigate } from 'react-router-dom';
import './Header.css';

const Header = ({ menus, onHomeClick }) => {
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <nav className="header-dashboards-nav">
            <ul className="header-dashboards-menu">
                {menus.map((menu, index) => (
                    <li
                        key={index}
                        className="header-menu-item-sidebar-dashboards"
                    >
                        <button
                            onClick={() => navigate(menu.path)}
                            className={`header-menu-button-sidebar-dashboards ${
                                location.pathname.includes(menu.path)
                                    ? 'active'
                                    : ''
                            }`}
                        >
                            <span>{menu.title}</span>
                        </button>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default Header;
